function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "matrix(1 0 0 -1 0 30)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#FF6756",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M15.1038095,10.0960322 C15.0668571,10.0960322 15.0304762,10.0934884 14.9948571,10.0882052 C14.9592381,10.0934884 14.9228571,10.0960322 14.8859048,10.0960322 L10.3834286,10.0960322 C11.0950476,11.4657463 11.0948571,13.5964344 11.0948571,15.5905425 C11.0948571,18.7761061 12.4413333,20.4667246 14.8859048,20.4667246 L15.1038095,20.4667246 C17.5485714,20.4667246 18.8948571,18.7761061 18.8948571,15.5905425 C18.8948571,13.5964344 18.8948571,11.4657463 19.6062857,10.0960322 L15.1038095,10.0960322 Z M15.4182857,7.76947494 C15.3415238,7.68670508 15.2201905,7.56734428 14.9605714,7.56734428 C14.708381,7.56734428 14.5958095,7.6931623 14.5259048,7.77104033 C14.3765714,7.93736276 14.2910476,8.13929775 14.2459048,8.53064464 L14.8859048,8.53064464 C14.9228571,8.53064464 14.9592381,8.53338406 14.9948571,8.53866725 C15.0304762,8.53338406 15.0668571,8.53064464 15.1038095,8.53064464 L15.7251429,8.53064464 C15.6712381,8.13929775 15.5777143,7.94108055 15.4182857,7.76947494 Z M20.46,15.5592347 C20.46,19.31186 18.8041905,21.6701163 15.9470476,22.0197848 L15.9470476,23.2163279 C15.9470476,23.6491575 15.6060952,24 15.1851429,24 C14.764,24 14.4232381,23.6491575 14.4232381,23.2163279 L14.4232381,22.0428742 C11.375619,21.7886944 9.61085714,19.4063703 9.61085714,15.5592347 C9.61085714,10.773258 9.05447619,10.0009349 7.77257143,10.0009349 C7.35161905,10.0009349 7,9.69861942 7,9.26578976 C7,8.8329601 7.3312381,8.53064464 7.75219048,8.53064464 L12.7062857,8.53064464 C12.7651429,7.94362431 12.9365714,7.22178498 13.4,6.70188064 C13.7950476,6.25868029 14.3346667,6 14.9605714,6 C15.5822857,6 16.1238095,6.26787694 16.5272381,6.70559843 C17.0078095,7.22726383 17.1984762,7.94362431 17.272,8.53064464 L22.2375238,8.53064464 C22.6586667,8.53064464 23,8.8329601 23,9.26578976 C23,9.69861942 22.6586667,10.0009349 22.2375238,10.0009349 C20.955619,10.0009349 20.46,10.773258 20.46,15.5592347 Z"
}));

function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.5c0e38d3.svg";
export { ForwardRef as ReactComponent };